<template>
    <VueSlideoutPanel
            v-model="state"
            :count=1
            :widths="widths"
            :styles="[{padding:0},{padding:'1rem 1rem 4rem'},{same:true}]"
            closeHtml=""
            @close="$emit('closeAside')">
        <div class="container-fluid">
            <b-row class="mb-3 mt-3">
                <b-col cols="10">
                  <h2>
                    <slot name="header_text"></slot>
                  </h2>
                </b-col>
                <b-col cols="2">
                    <a @click.prevent="$emit('closeAside')" class="pull-right" href="#"><i class='fa fa-times fa-2x'
                                                                                           aria-hidden='true'></i></a>
                </b-col>
            </b-row>
            <slot></slot>
        </div>
    </VueSlideoutPanel>
</template>

<script>
    // docs on https://lyollix.github.io/vue-slideout-panel-demo/
    import VueSlideoutPanel from 'vue-slideout-panel'

    export default {
        name: "AppAside",
        components: {
            VueSlideoutPanel
        },
        props: {
            state: {
                delfault: false,
                type: Boolean
            },
            keep_alive:{
                delfault: false,
                type: Boolean
            },

          widths: {
            default: () => {
              return ['col-lg-5', 'col-sm-12', '40%']
            }
          }
        }
    }
</script>

<style scoped>

</style>
